import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Pages from './pages/Pages';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './context/StoreContext';

import 'semantic-ui-css/semantic.min.css'

ReactDOM.render(
  <BrowserRouter>
    <AppProvider>
      <Pages />
    </AppProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
